import { render, staticRenderFns } from "./project_view.vue?vue&type=template&id=8e6c079a&scoped=true&"
import script from "./project_view.vue?vue&type=script&lang=ts&"
export * from "./project_view.vue?vue&type=script&lang=ts&"
import style0 from "./project_view.vue?vue&type=style&index=0&id=8e6c079a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6c079a",
  null
  
)

export default component.exports